import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ErrorService } from '../services/error.service';

@Injectable()
export class AddTokenInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private authService: AuthService,
    private _errorService: ErrorService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
  const token = localStorage.getItem('token')
  if(token) {
    request = request.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
  }

    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        const backendMessage = error.error?.msg || error.error?.error || '';
        const mustCloseSession =
          error.status === 401 ||
          (error.status === 403 && /deshabilitado/i.test(String(backendMessage)));

        if (mustCloseSession) {
          this.authService.clearSession();
          this._errorService.msjError(error)
          this.router.navigate(['/login'])
        }
        return throwError(() => error);
      })
    );
  }
}
